'use client';

import { Expand } from '@/components/ui/Expand/Expand';
import { LinkButton } from '../Button/Button';
import { getFaq, type FaqType } from './utils';
import { arialNarrowBold } from '@/utils/font';

export const FaqTeaser = ({ type = 'general' }: { type?: FaqType }) => {
  const faqs = getFaq(type);
  return (
    <div id="faq" className="max-w-6xl px-4 mx-auto sm:px-6 flex flex-col gap-8 lg:flex-row w-full">
      <div
        className={
          'flex flex-row lg:flex-col gap-8 lg:min-w-[400px] lg:max-w-[500px] items-center lg:items-start justify-between lg:justify-start w-full'
        }
      >
        <h3
          className={`text-3xl uppercase lg:text-4xl xl:text-5xl text-white ${arialNarrowBold.className}`}
        >
          Frequently Asked Questions
        </h3>
        <div className="hidden md:block">
          <LinkButton
            href={'/about'}
            isSecondary={true}
            className="text-sm sm:text-base w-full md:max-w-[230px]"
          >
            About TONE3000
          </LinkButton>
        </div>
      </div>
      <div className={'flex flex-col gap-4 w-full'}>
        {faqs.map((faq, i) => (
          <Expand title={`${faq.title}`} key={`general-${faq.title}-${i}`}>
            {faq.description}
          </Expand>
        ))}
      </div>
      <div className="block md:hidden">
        <LinkButton
          href={'/about'}
          isSecondary={true}
          className="text-sm sm:text-base w-full md:max-w-[230px]"
          aria-label="Visit About page"
        >
          About TONE3000
        </LinkButton>
      </div>
    </div>
  );
};
